import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  userInfo: null, // Optional: Hier könntest du weitere User-Infos speichern, z. B. Name, Rolle etc.
  proMember: false, // Track if user is a pro member
  debugMode: false, // Add debug mode state
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLogin(state, action) {
      state.isLoggedIn = true;
      state.userInfo = action.payload; // Bsp.: userCredential.user oder andere Infos
      // Check if user is a pro member from the payload
      state.proMember = action.payload?.proMember || false;
    },
    setLogout(state) {
      state.isLoggedIn = false;
      state.userInfo = null;
      state.proMember = false;
      state.debugMode = false;
    },
    setProMember(state, action) {
      state.proMember = action.payload;
    },
    setDebugMode(state, action) {
      state.debugMode = action.payload;
    },
  },
});

export const { setLogin, setLogout, setProMember, setDebugMode } =
  userSlice.actions;
export default userSlice.reducer;
